import ReactDOM from "react-dom/client";
import "./index.css";
import i18n, { injectStoreForI18n } from "./config/i18n";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CsApp from "./CsApp";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./redux-store/store";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@mui/material";
import { theme } from "./styles/constant";
import { injectStore } from "./axios/axiosInstance";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { injectStoreApiService } from "./redux-store/CSApiService";
import { nanoid } from "@reduxjs/toolkit";
import CsSessionStorageUtils from "./utils/CsSessionStorageUtils";
import { isEmpty } from "lodash";
import { injectStoreForAxiosUtils } from "./axios/axiosEncryptionUtils";
import { I18nextProvider } from "react-i18next";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

injectStore(store);
injectStoreForAxiosUtils(store);
injectStoreForI18n(store);

injectStoreApiService(store);

if (isEmpty(CsSessionStorageUtils.get("TRACE_ID"))) {
  let randomTraceId = "CS" + nanoid(14);
  CsSessionStorageUtils.set("TRACE_ID", randomTraceId);
}
root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ThemeProvider theme={theme}>
            <CsApp />
          </ThemeProvider>
        </LocalizationProvider>
      </BrowserRouter>
    </Provider>
  </I18nextProvider>,
  // </React.StrictMode>
);

// run non-critical inits after first render to avoid blocking paint
setTimeout(() => {
  persistor.persist();
}, 0);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register();
